import { PortfolioAllocation, PortfolioAllocationDataPoint } from '@models';
import { sortPortfolioDataPoints } from '@products/portfolio/portfolio.utils';
import {
  PortfolioComponentId,
  PortfolioCouponAllocationDTO,
  PortfolioDTO,
} from '@types';
import { Logger } from '@utils/logger';
import { formatPercentage } from '@utils/text/number-utils';
import { MapperFactory } from '../mapper-factory';
import { getFirstNonEmptyProp, parseStdNumber, parseYN } from '../mapper.utils';
import { Mapper, MapperParams } from '../type.mapper';

const logger = Logger.getLogger('CouponAllocationMapper');

// tslint:disable-next-line:max-line-length
// example fund: https://en-us.staging.ftsites.com/investments/options/mutual-funds/products/4110/R6/franklin-u-s-government-securities-fund/FGORX#portfolio
export class CouponAllocationMapper extends Mapper<PortfolioAllocation[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(portfolioDto: PortfolioDTO): PortfolioAllocation[] {
    const data: PortfolioCouponAllocationDTO[] = portfolioDto.couponallocation;

    // if no data, return null
    if (!data || data.length === 0) {
      return null;
    }

    const allocation: PortfolioAllocation = {
      componentId: PortfolioComponentId.COUPON_ALLOCATION,
      baseLabelKey: 'coupon-allocation',
      allocationFlag: getFirstNonEmptyProp(data, 'allocflag'),
      allocationHeading: getFirstNonEmptyProp(data, 'allocheadinglocal'),
      asOfDate: getFirstNonEmptyProp(data, 'asofdate'),
      calculationBasis: getFirstNonEmptyProp(data, 'calcbasislocal'),
      calculationType: getFirstNonEmptyProp(data, 'calctypelocal'),
      hasDerivatives: parseYN(getFirstNonEmptyProp(data, 'hasderivatives')),
      updateFrequency: getFirstNonEmptyProp(data, 'frequency'),
      data: data.sort(sortPortfolioDataPoints).map(
        (obj: PortfolioCouponAllocationDTO): PortfolioAllocationDataPoint => ({
          label: obj.rangedesc,
          breakdown: formatPercentage(obj.brkdwnpct),
          breakdownStd: parseStdNumber(obj.brkdwnpctstd),
        })
      ),
    };
    return [allocation];
  }
}
